import { __extends } from "tslib";
import { useState } from 'react';
import { uuid4 } from '../utils/uuid';
import { createBus } from './bus';
var SharedStateInitializationError = /** @class */ (function (_super) {
    __extends(SharedStateInitializationError, _super);
    function SharedStateInitializationError(message) {
        return _super.call(this, message) || this;
    }
    return SharedStateInitializationError;
}(Error));
export { SharedStateInitializationError };
export function createSharedState(initial) {
    var uniqBus = uuid4();
    var _a = createBus(), useBus = _a.useBus, dispatch = _a.dispatch;
    var mutableState = initial;
    var setter = function (s) {
        mutableState = s;
        dispatch({ type: uniqBus, s: s });
    };
    return {
        setSharedState: setter,
        getSharedState: function () {
            if (typeof mutableState === 'undefined') {
                throw new SharedStateInitializationError();
            }
            return mutableState;
        },
        useSharedState: function () {
            var _a = useState(mutableState), state = _a[0], setState = _a[1];
            if (typeof state === 'undefined') {
                throw new SharedStateInitializationError();
            }
            useBus(uniqBus, function (_a) {
                var s = _a.s;
                setState(s);
            }, [setState]);
            return [state, setter];
        },
    };
}
//# sourceMappingURL=shared-state.js.map